import { render } from "./GroupManageUsers.vue?vue&type=template&id=64c06f28"
import script from "./GroupManageUsers.vue?vue&type=script&lang=js"
export * from "./GroupManageUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__